import axios from "axios";
import axiosInstance from "./instance";
const instance = axiosInstance();


export const getAllLeadsData = async (page,size) => {
    try {
        const response = await instance.get(`lead?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const updateLeadsData = async (id,data) => {
    try {
        const response = await instance.put(`lead/${id}`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const addLeadsData = async (data) => {
    try {
        const response = await instance.post(`lead`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const removeLeadsData = async (id) => {
    try {
        const response = await instance.delete(`lead/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const searchLeadsData = async (page,size,data) => {
    try {
        const response = await instance.post(`lead/search?page=${page}&size=${size}`,data);
        return response;
    } catch (error) {
        return error;
    }
}